import { put, all } from "redux-saga/effects";

import makeRequest from "rdx/utils/makeRequest";
import getErrorActions from "rdx/utils/getErrorActions";
import actions from "rdx/actions";
import messages from "rdx/modules/users/messages";

function* getPermissionsOperations() {
  const { success, data, error } = yield* makeRequest.get("/operations", {});

  if (success && data) {
    yield all([
      put(actions.setRolesList({ operations: data.body.operations })),
      put(actions.newSuccessEvent({ message: messages.FETCH_OPERATIONS_SUCCESS })),
    ]);
  } else if (error) {
    return getErrorActions({
      error,
      message: messages.ERROR_GETTING_PERMISSIONS_OPERATIONS,
    });
  }

  return null;
}

export default getPermissionsOperations;
